module.exports = __webpack_public_path__ + "static/fugyep-3-a37f77f6e822ca10c5237d3bb966fd1e.png";